import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Button, Typography } from "@mui/material"
import { getDoc, updateDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { toast } from 'react-toastify'
import dayjs from "dayjs"
import { setIndividualStatus } from "./admin/lib/common"
import { StepFormConfirm } from "./lib/StepFormConfirm"
import { FormProps } from "./lib/StepForm"

const ArrivalRegistrationConfirm = () => {
  const urlParams = useParams<{ individualId: string }>()
  const [values, setValues] = useState<Record<string, string>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'individual')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf.filter((form: FormProps) => form.isArrivalElements))
    })
    const storageValues = sessionStorage.getItem('individual')
    storageValues && setValues(JSON.parse(storageValues))
  }, [])

  const onSave = () => {
    try {
      const individualDoc = doc(collection(db, 'individuals'), urlParams.individualId)

      // データを事前に検証
      const updateData = setIndividualStatus({
        ...values,
        updatedAt: dayjs().toDate() // または Timestamp.now()
      })

      console.log('Update data:', updateData) // デバッグ用

      updateDoc(individualDoc, updateData)
        .then(() => {
          toast.success("個体到着情報を登録しました")
          sessionStorage.removeItem('individual')
          navigate(`/`)
        })
        .catch(e => {
          console.error('Firestore error:', e) // 詳細なエラー情報
          toast.error(`エラー: ${e.message}`)
        })
    } catch (error) {
      console.error('Validation error:', error)
      toast.error('データの形式に問題があります')
    }
  }

  return (
    <Box>
      <Typography>捕獲個体到着登録</Typography>
      <StepFormConfirm forms={forms} values={values}/>
      <Box mt={2} display="flex" justifyContent="center">
        <Button variant="outlined" onClick={() => navigate(`/individuals/${urlParams.individualId}/arrival/regist`)}>戻る</Button>
        <Button variant="contained" onClick={onSave} sx={{ ml: 2 }}>登録</Button>
      </Box>
    </Box>
  )
}

export default ArrivalRegistrationConfirm
